module.exports = __webpack_public_path__ + "static/media/banner-2.1c6ad997.png";